import React, { SVGAttributes, useState } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconLineSegmentLeftExclusive: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect x="5" y="7" width="9" height="2" />
      <path d="M3,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S1,9.1,1,8S1.9,6,3,6 M3,5C1.34,5,0,6.34,0,8s1.34,3,3,3s3-1.34,3-3S4.66,5,3,5L3,5z" />
      <circle cx="13" cy="8" r="3" />
    </svg>
  );
};

export default IconLineSegmentLeftExclusive;
